import { FC } from "react";
import ContactAndSafetyInfo from "src/components/contactAndSafetyInfo";
import { TextAlignProps } from "src/components/contactAndSafetyInfo/types";

const PrivacyPage: FC = (): JSX.Element => {
  return (
    <div className="py-2 container">
      <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_END} textColor="black" />
      <h1>Privacy Policy</h1>
    </div>
  );
};

export default PrivacyPage;
